import React from "react";
import "./TourStep.css";
export var tourStepsForAdmin = [{
  selector: ".tour-first-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Manage Teams "), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "You can create teams for your company from this manage teams page"));
  }
}, {
  selector: ".tour-second-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Manage Employees"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "On this page, you can add new employees"));
  }
}, {
  selector: ".tour-third-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Track Settings"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "From here you can manage your company's track settings, customize the track settings and more"));
  }
}, {
  selector: ".tour-fourth-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Overview"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "Keep track of the employees in real time with live information. You can see summary of apps usage, latest screenshots and work timings"));
  }
}, {
  selector: ".tour-fifth-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "That concludes the tour"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "If you have any problems or issues we are here to help, feel free to browse our knowledge base or open a ticket with our support team if you'd like to learn more"));
  }
}];
export var tourStepsForHead = [{
  selector: ".tour-second-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Manage Employees"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "When you want to add a new user, click on this add new employee button"));
  }
}, {
  selector: ".tour-fourth-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "Overview"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "Keep track of the employees in real time with live information. You can see summary of apps usage, latest screenshots and work timings"));
  }
}, {
  selector: ".tour-fifth-step",
  content: function content() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "react-tour-header-text"
    }, "That concludes the tour"), /*#__PURE__*/React.createElement("p", {
      className: "react-tour-content-text"
    }, "If you have any problems or issues we are here to help, feel free to browse our knowledge base or open a ticket with our support team if you'd like to learn more"));
  }
}];